import { MdOutlineAccountTree } from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Layout from "../Layout";
import Table from "antd/lib/table";
import { Tooltip, Breadcrumb } from "antd";
import { Toaster } from "react-hot-toast";
import {
    fetchAllSupportdataByUser,
    fetchGetAccessedApps,
    fetchGetAccessedCompanies,
    fetchGetAccessedRequestedBy,
    fetchGetAccessedSites,
    fetchUserMenudata,
} from "../../Redux/Api/fetch.api";
import Title from "../Title";
import searchIcon from "../../assets/images/search_icon.svg";
import whatsapp from "../../assets/images/whatsapp.png";
import SMS from "../../assets/images/sms.png";
import video_call from "../../assets/images/video_option.svg";
import call_icon from "../../assets/images/call_option.svg";
import email_icon from "../../assets/images/mail_option.svg";
import chat_icon from "../../assets/images/chat_option.svg";
import { HistoryEdu as HistoryEduIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MdClear } from "react-icons/md";

const UserSupports = () => {
    const searchFilterref = useRef(null);
    const { t } = useTranslation("version");
    const history = useHistory();
    const loggedUserId = localStorage.getItem("UserId");
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;
    const [assignedtable, setAssignedTable] = useState([]);


    // state for support filters
    const [filterState, setFilterState] = useState({});
    const [apps, setApps] = useState([]);
    const [company, setCompany] = useState([]);
    const [sites, setSites] = useState([]);
    const [requestedBy, setRequestedBy] = useState([]);

    const [statusFilter, setStatusFilter] = useState([]);
    const [priorityFilter, setPriorityFilter] = useState([]);
    const [companyFilter, setCompanyFilter] = useState([]);
    const [appFilter, setAppFilter] = useState([]);
    const [siteFilter, setSiteFilter] = useState([]);
    const [requestedbyFilter, setRequestedbyFilter] = useState([]);

    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const dropdownRef = useRef(null);
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: parseInt(REACT_APP_DEFAULT_PAGESIZE || 50),
            total: 0,
            pageSizeOptions: ["50", "100"],
            showSizeChanger: true,
        },
    });

    const [roleId, setUserRoleId] = useState(); // replace or connect if dynamic roleId logic is planned

    useEffect(() => {
        const getApps = async () => {
            try {
                const data = await fetchGetAccessedApps(parseInt(loggedUserId));
                const transformed = data?.data?.data?.map((item) => ({
                    id: item.appId,
                    title: item.name,
                }));

                setApps(transformed);
            } catch (error) {
                console.error("Error fetching accessed apps:", error);
            }
        };

        const getCompanies = async () => {
            try {
                const data = await fetchGetAccessedCompanies(parseInt(loggedUserId));
                const transformed = data?.data?.data?.map((item) => ({
                    id: item.companyId,
                    title: item.companyName,
                }));

                setCompany(transformed);
            } catch (error) {
                console.error("Error fetching accessed apps:", error);
            }
        };

        const getSites = async () => {
            try {
                const data = await fetchGetAccessedSites(parseInt(loggedUserId));

                const transformed = data?.data?.data?.map((item) => ({
                    id: item.siteId,
                    title: item.siteName,
                }));
                setSites(transformed);
            } catch (error) {
                console.error("Error fetching accessed apps:", error);
            }
        };

        const getRequestBy = async () => {
            try {
                const data = await fetchGetAccessedRequestedBy(parseInt(loggedUserId));
                const transformed = data?.data?.data?.map((item) => ({
                    id: item.lastName + " " + item.firstName,
                    title: item.lastName + " " + item.firstName,
                }));
                setRequestedBy(transformed);
            } catch (error) {
                console.error("Error fetching accessed apps:", error);
            }
        };
        const getUserDetails = () => {
            fetchUserMenudata(parseInt(loggedUserId))
                .then(response => {
                    setUserRoleId(response.data.data.userRoleDetails[0].roleId)
                })
                .catch((err) => {
                    console.error("Err: ", err);
                });
        }

        getApps();
        getCompanies();
        getSites();
        getRequestBy();
        getUserDetails();
    }, []);

    const showPagination = totalCount > options.pagination.pageSize;

    // Get the support data accessed for current user
    const getAllSupportdataByUser = () => {
        const supportIdParsed = parseInt(searchFilterref.current?.value, 10);
        setLoading(true);

        const payload = {
            userId: parseInt(loggedUserId),
            pageNumber: options.pagination.current,
            pageSize: options.pagination.pageSize,
            supportId: isNaN(supportIdParsed) ? null : supportIdParsed,
            priority: priorityFilter.count === 0 ? null : priorityFilter,
            status: statusFilter.count === 0 ? null : statusFilter,
            apps: appFilter.count === 0 ? null : appFilter,
            companies: companyFilter.count === 0 ? null : companyFilter,
            sites: siteFilter.count === 0 ? null : siteFilter,
            requestedBy: requestedbyFilter.count === 0 ? null : requestedbyFilter
        };

        fetchAllSupportdataByUser(payload)
            .then((response) => {
                setAssignedTable(response.data.data);
                setTotalCount(response.data?.data[0].totalCount)
            })
            .catch((err) => console.error("Error fetching data:", err))
            .finally(() => setLoading(false));
    };

    const onSubmitFilterForm = (e) => {
        e.preventDefault();
        debugger;

        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                pageSize: REACT_APP_DEFAULT_PAGESIZE,
                current: 1,
                total: prev.pagination.total,
                pageSizeOptions: ['50', '100'],
                showSizeChanger: true,
            }
        }));

        getAllSupportdataByUser();
    };

    const resetFilter = () => {
        if (searchFilterref.current) {
            searchFilterref.current.value = "";
        }
        setFilterState({});
        setPriorityFilter([]);
        setStatusFilter([]);
        setAppFilter([]);
        setCompanyFilter([]);
        setSiteFilter([]);
        setRequestedbyFilter([]);
    };

    //Save all the selected data to save state and add the specific data to the filter list depending the title
    const getFilterData = (e, option, title, index) => {
        const isChecked = e.target.checked;
        debugger;

        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                pageSize: REACT_APP_DEFAULT_PAGESIZE,
                current: 1,
                total: prev.pagination.total,
                pageSizeOptions: ['50', '100'],
                showSizeChanger: true,
            }
        }));

        setFilterState((prev) => {
            const prevOptions = prev[title] || [];
            const updatedOptions = isChecked
                ? [...prevOptions, option]
                : prevOptions.filter((item) => item !== option);

            return {
                ...prev,
                [title]: updatedOptions,
            };
        });

        switch (title) {
            case "Priority":
                setPriorityFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            case "App":
                setAppFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            case "Status":
                setStatusFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            case "Company":
                setCompanyFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            case "Site":
                setSiteFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            case "Requested By":
                setRequestedbyFilter((prev) => {
                    if (isChecked) {
                        return [...prev, index];
                    } else {
                        return prev.filter((i) => i !== index);
                    }
                });
                break;
            default:
                break;
        }
    };

    // clears the array for the matching title
    const clearSpecificFilter = (title) => {
        setFilterState((prev) => ({
            ...prev,
            [title]: [],
        }));
        switch (title) {
            case "Priority":
                setPriorityFilter([]);
                break;
            case "Status":
                setStatusFilter([]);
                break;
            case "App":
                setAppFilter([]);
                break;
            case "Company":
                setCompanyFilter([]);
                break;
            case "Site":
                setSiteFilter([]);
                break;
            case "Requested By":
                setRequestedbyFilter([]);
                break;
            default:
                break;
        }
    };

    //make sure the order data in the options are same in the enum
    const supportFilterdata = [
        {
            title: "Company",
            options: company,
        },
        {
            title: "Site",
            options: sites,
        },
        {
            title: "App",
            options: apps,
        },
        {
            title: "Requested By",
            options: requestedBy,
        },
        {
            title: "Priority",
            options: [
                { id: 1, title: "High" },
                { id: 2, title: "Medium" },
                { id: 3, title: "Low" },
            ],
        },
        {
            title: "Status",
            options: [
                { id: 0, title: "Active" },
                { id: 1, title: "Pending" },
                { id: 2, title: "Working" },
                { id: 3, title: "Closed" },
                { id: 4, title: "New" },
            ],
        },
    ];

    useEffect(() => {
        getAllSupportdataByUser();
    }, [filterState, options]);

    const handleSupportLog = (supportId) => {
        history.push(`/LogDetails/${supportId}`);
    };

    const openWorkitemEdit = (id, supportid) => {
        // window.location.href = `/Workitem/Edit/${id}/${supportid}`;
        history.push(`/Workitem/Edit/${id}/${supportid}`);
    };

    const assignedcolumns = [
        {
            title: "Request ID",
            dataIndex: "supportId",
        },

        {
            title: "Case ID",
            key: "caseId",
            dataIndex: "workitemid",
            render: (workitemid, row, index) =>
                workitemid ? (
                    <div
                        className="sup-workItem-container"
                        onClick={() => openWorkitemEdit(workitemid, row.supportId)}
                        style={{ cursor: "pointer" }}
                    >
                        <span className="sup-workItem-highlight">{`#${workitemid}`}</span>
                    </div>
                ) : null,
        },

        {
            title: "Company",
            dataIndex: "companyName",
        },

        {
            title: "Site",
            dataIndex: "siteName",
        },

        {
            title: "App",
            dataIndex: "appName",
        },

        {
            title: "Request Type",
            dataIndex: "RequestType",
            render: (value, item, index) => (
                <>
                    {
                        <>
                            {item.requestType === 1 && (
                                <div className="centered-container ">
                                    <Tooltip title="Requested for Audio call">
                                        <button className="support-log-request">
                                            <img src={call_icon} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}

                            {item.requestType === 0 && (
                                <div className="centered-container ">
                                    <Tooltip title="Requested for Live Chat">
                                        <button className="support-log-request">
                                            <img src={chat_icon} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}

                            {item.requestType === 2 && (
                                <div className="centered-container ">
                                    <Tooltip title="Requested for Video Call">
                                        <button className="support-log-request">
                                            <img src={video_call} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}

                            {item.requestType === 3 && (
                                <div className="centered-container">
                                    <Tooltip title="Requested for Email">
                                        <button className="support-log-request">
                                            <img src={email_icon} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}

                            {item.requestType === 4 && (
                                <div className="centered-container ">
                                    <Tooltip title="Requested for Whatsapp">
                                        <button className="support-log-request">
                                            <img src={whatsapp} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}

                            {item.requestType === 5 && (
                                <div className="centered-container ">
                                    <Tooltip title="Requested for SMS">
                                        <button className="support-log-request">
                                            <img src={SMS} className="apply-img"></img>
                                        </button>
                                    </Tooltip>
                                </div>
                            )}
                        </>
                    }
                </>
            ),
        },

        {
            title: "Description",
            dataIndex: "description",
            className: "description_support",
            render: (description) => (
                <Tooltip title={description}>{description}</Tooltip>
            ),
        },

        {
            title: "Requested By",
            dataIndex: "requestedBy",
            className: "name-wrap",
        },

        {
            title: "Request Date",
            dataIndex: "requestDate",
            className: "date-wrap",
        },

        {
            title: "Communicate By",
            dataIndex: "phoneNumber",
            className: "date-wrap",
            render: (text, record, index) => (
                <>
                    {record.requestType === 1 ||
                        record.requestType === 4 ||
                        record.requestType === 5 ? (
                        <div
                            style={{ display: "flex", height: "100%" }}
                            className="communication-by"
                        >
                            {record.phoneNumber}
                        </div>
                    ) : record.emailId != "null" ? (
                        <div
                            style={{ display: "flex", height: "100%" }}
                            className="communication-by"
                        >
                            {record.emailId}
                        </div>
                    ) : (
                        ""
                    )}
                </>
            ),
        },

        {
            title: t("Priority"),
            dataIndex: "priority",
            render: (value, item) => {
                const getClass = (priority) => {
                    if (priority === 1) return "priority-high";
                    if (priority === 2) return "priority-medium";
                    return "priority-low";
                };

                const getText = (priority) => {
                    if (priority === 1) return "High";
                    if (priority === 2) return "Medium";
                    return "Low";
                };

                return (
                    <span className={getClass(item.priority)}>
                        {getText(item.priority)}
                    </span>
                );
            },
        },

        {
            title: "Assigned To",
            dataIndex: "assignedName",
            className: "name-wrap",
            render: (text, record, index) => (
                <>
                    {record.assignedDate && record.userId > 0 ? (
                        record.assignedName
                    ) : (
                        <div>
                            <span className="not-yet-assigned">{"Not yet assigned"}</span>
                        </div>
                    )}
                </>
            ),
        },

        {
            title: "Assigned Date",
            dataIndex: "assignedDate",
            className: "date-wrap",
        },

        {
            title: "Start Date",
            dataIndex: "startDate",
            className: "date-wrap",
        },

        {
            title: t("Status"),
            dataIndex: "status",
            render: (value, item) => {
                if (item?.status === 3) {
                    return <span className="status-resolved">Closed</span>;
                } else if (item?.assignedDate && item?.userId > 0) {
                    return <span className="status-active">Active</span>;
                } else {
                    return <span className="status-new">New</span>;
                }
            },
        },

        {
            title: "Closed Date",
            dataIndex: "closedDate",
            className: "date-wrap",
        },

        {
            title: t("Log"),
            render: (record) =>
                record.supportId !== null && record.assignedDate != null ? (
                    <div className="support-log-btn">
                        <Tooltip title="Click to view Log">
                            <HistoryEduIcon
                                onClick={() => handleSupportLog(record.supportId)}
                                style={{ cursor: "pointer", color: "#000" }}
                            />
                        </Tooltip>
                    </div>
                ) : null,
        },
    ];

    return (
        <div>
            <Title title="Support Request" />
            <Layout>
                <section className="Company_section common">
                    <div className="container workitem-container">
                        <Toaster />

                        <div className="heading-title d-flex align-items-lg-center gap-3 w-100 py-3 flex-column-reverse flex-lg-row">
                            <h2 className="m-0 text-white">Support Logs</h2>
                            <Breadcrumb
                                className="ml-lg-auto ml-0 p-0 mb-0 w-auto"
                                itemRender={(route) =>
                                    route.path ? (
                                        <Link to={route.path}>{route.breadcrumbName}</Link>
                                    ) : (
                                        <span>{route.breadcrumbName}</span>
                                    )
                                }
                                items={[
                                    { breadcrumbName: "Dashboard", path: "/Dashboard" },
                                    { breadcrumbName: "Support", path: "" },
                                    { breadcrumbName: "Support Logs", path: "" },
                                ]}
                            />
                        </div>

                        <div className="support-black-box d-flex flex-wrap gap-3 align-items-center mb-4">
                            <div className="d-flex flex-wrap right-section">
                                <div className="d-flex position-relative searchBox">
                                    <form
                                        onSubmit={onSubmitFilterForm}
                                        className="d-flex align-items-center"
                                    >
                                        <input
                                            ref={searchFilterref}
                                            type="number"
                                            className="form-control searchQR search-suppport-input"
                                            placeholder={t("Search by Request ID or Case ID")}
                                        />
                                        <button type="submit" className="searchButton mt-sm-0">
                                            <img src={searchIcon} alt="search" />
                                        </button>
                                    </form>
                                </div>
                                {(searchFilterref.current?.value !== "" ||
                                    Object.values(filterState).some(
                                        (arr) => Array.isArray(arr) && arr.length > 0
                                    )) && (
                                        <button
                                            onClick={resetFilter}
                                            className="btn btn-primary d-flex align-items-center btn-new"
                                        >
                                            {t("Reset")}
                                        </button>
                                    )}
                            </div>

                            <div className="more-filter ml-auto">
                                <ul classN0ame="list-inline py-3">
                                    {supportFilterdata.filter(item => !(roleId !== 7 && item.title === "Company"))
                                        .map((item, index) => (
                                            <li key={index} className="list-inline-item">
                                                <div class="assigned-drop common-drop dropdown">
                                                    <button className="btn text-white dropdown-toggle" aria-expanded="false" type="button" id={`dropdownMenuButton-${index}`} data-bs-toggle="dropdown">
                                                        {item.title}
                                                    </button>

                                                    <ul class="dropdown-menu support-menu-lists" aria-labelledby="dropdownMenuButton1">
                                                        {item.options.map((option, idx) => (
                                                            <li key={idx} className="px-3">
                                                                <a class="dropdown-item d-flex flex-wrap">
                                                                    <input
                                                                        checked={filterState[item.title]?.includes(option.title) || false}
                                                                        onChange={(e) => getFilterData(e, option.title, item.title, option.id)} type="checkbox" class="form-check-input cursor-pointer" name="checkcategory"
                                                                    />
                                                                    <label className="form-check-label ml-2 non-clickable text-wrap" for="exampleCheck1">{option.title}</label>
                                                                </a>
                                                            </li>
                                                        ))}

                                                        <li className="pr-3 text-right" key={'no-Key'} >
                                                            {filterState[item.title]?.length > 0 && (
                                                                <button
                                                                    onClick={() => clearSpecificFilter(item.title)}
                                                                    className="button-34"
                                                                >
                                                                    Clear <MdClear />
                                                                </button>
                                                            )}
                                                        </li>

                                                    </ul>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>

                        <div className="d-flex flex-wrap justify-content-between align-items-center w-100 mb-3">
                            <span className="fs-5 fw-bold text-white mb-2 mb-sm-0 order-1">Support logs</span>
                            <span className="d-flex align-items-center text-white order-2 order-sm-2 ms-auto ms-sm-0">
                                <MdOutlineAccountTree className="me-2" />
                                Total Count : {totalCount}
                            </span>
                        </div>

                        {/*<div className="report-header d-flex justify-content-between align-items-center mb-2">*/}
                        {/*    <div className="load-report">*/}
                        {/*        <div className="search-order-outer">*/}
                        {/*            <Space direction="vertical">*/}
                        {/*                <DatePicker*/}
                        {/*                    format="MM/DD/YYYY HH:mm:ss"*/}
                        {/*                    showTime*/}
                        {/*                    placeholder={t("SelectStartDateandTime")}*/}
                        {/*                    renderExtraFooter={() => (*/}
                        {/*                        <div className="timePickerHeader">*/}
                        {/*                            <div>Hr</div><div>Min</div><div>Sec</div>*/}
                        {/*                        </div>*/}
                        {/*                    )}*/}
                        {/*                />*/}
                        {/*            </Space>*/}

                        {/*            <Space direction="vertical">*/}
                        {/*                <DatePicker*/}
                        {/*                    format="MM/DD/YYYY HH:mm:ss"*/}
                        {/*                    showTime*/}
                        {/*                    placeholder={t("SelectEndDateandTime")}*/}
                        {/*                    renderExtraFooter={() => (*/}
                        {/*                        <div className="timePickerHeader">*/}
                        {/*                            <div>Hr</div><div>Min</div><div>Sec</div>*/}
                        {/*                        </div>*/}
                        {/*                    )}*/}
                        {/*                />*/}
                        {/*            </Space>*/}

                        {/*            <Tooltip title={t("Clicktosearchrequest")}>*/}
                        {/*                <button className="search-button-icon">*/}
                        {/*                    <img src={searchIcon} alt="Search" />*/}
                        {/*                </button>*/}
                        {/*            </Tooltip>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="Viewer-table index--table position-relative common-table mb-2">
                            <Table
                                className="table-responsive antd--detail-table1"
                                columns={assignedcolumns}
                                dataSource={assignedtable}
                                loading={loading}
                                pagination={{
                                    ...options.pagination,
                                    total: totalCount,
                                    current: options.pagination.current,
                                    pageSize: options.pagination.pageSize,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    disabled: false,
                                    showLessItems: false,
                                }}
                                onChange={(pagination) => {
                                    setOptions((prev) => ({
                                        ...prev,
                                        pagination: {
                                            ...prev.pagination,
                                            current: pagination.current,
                                            pageSize: pagination.pageSize,
                                        }
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default UserSupports;
